// React
import React from 'react';
import { Controller } from 'react-hook-form';
// custom components
import NumberedHeading from '../../../../../shared-components/forms/NumberedHeading';
import PEDecisionEventArray from './components/PEDecisionEventArray';

const PEDecisionEvent = (props) => {
  const { control, formState } = props.methods;
  const { errors } = formState;
  const { inputDir, possiblePages } = props;

  return (
    <div>
      <NumberedHeading
        number="1"
        title="Options"
        instructions="Using the controls below, add a decision point in the Practical Exercise."
      />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => (
          <PEDecisionEventArray
            inputDir={inputDir}
            {...{ control, errors }}
            possiblePages={possiblePages}
          />
        )}
      />
    </div>
  );
};

export default PEDecisionEvent;
